import {DEFAULT_LINE_PLOT_SETTINGS} from '../../WorkspaceDrawer/Settings/runLinePlots/linePlotDefaults';
import {
  createBooleanDisplayFn,
  createNumberDisplayFn,
} from './displayValueFactory';

export const getYLogScaleDisplayRow = createBooleanDisplayFn({
  field: 'yLogScale',
  label: 'Log scale',
  groupTitle: 'Y axis',
  defaultValue: DEFAULT_LINE_PLOT_SETTINGS.yLogScale,
});

export const getYAxisMinDisplayRow = createNumberDisplayFn({
  field: 'yAxisMin',
  label: 'Min',
  groupTitle: 'Y axis',
});

export const getYAxisMaxDisplayRow = createNumberDisplayFn({
  field: 'yAxisMax',
  label: 'Max',
  groupTitle: 'Y axis',
});
